import { useState, useRef, useEffect } from "react";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";

const EntryConfigTable = ({
  resp,
  isNeedAddRec,
  setNeedAddRec,
  configSource,
  sourceData,
  changeUsage,
  setSourceData,
  getData,
}) => {
  const trRef = useRef(null);
  const isMounted = useRef(true);

  const [name, setName] = useState("");
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [used, setUsed] = useState(false);
  const [main, setMain] = useState(false);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  async function changeMain(name) {
    const data = [configSource, name];
    setSourceData(null);
    await api.post(E.CHANGE_MAIN, 4, { data: data });
    getData();
  }

  function resetInputs() {
    setName("");
    setLogin("");
    setPass("");
    setUsed(false);
    setMain(false);
  }

  async function addRecord() {
    const data = {
      type: configSource,
      name,
      login,
      pass,
      is_used: used,
      is_main: main,
    };

    await api.post(E.ADD_CONFIG, 4, { data: [data] });
    setNeedAddRec(false);

    resetInputs();
    getData();
  }

  const handleAddClick = () => {
    if (!isNeedAddRec) {
      setNeedAddRec(true);
    } else {
      addRecord();
    }
  };

  return (
    <>
      <div className="admin_table-container">
        <table className="admin_config-table">
          <thead className="admin_config-table">
            <tr ref={trRef}>
              <th>Наименование</th>
              <th>Используется</th>
              <th>{configSource === "avito" ? "Главная" : "Действие"}</th>
              <th>Логин</th>
              <th>Пароль</th>
            </tr>
          </thead>
          <tbody className="admin_config-table">
            {resp.map((item, ind) => (
              <tr key={`${sourceData}-${ind}`}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={item.is_used}
                    onChange={(e) => changeUsage(item.name, e.target.checked)}
                  />
                </td>
                <td>
                  {configSource === "avito" ? (
                    <input
                      type="checkbox"
                      checked={item.is_main}
                      onChange={() => changeMain(item.name)}
                    />
                  ) : (
                    <select
                      defaultValue={item.is_main}
                      onChange={(e) => {
                        changeUsage(item.name, e.target.value);
                      }}
                    >
                      <option selected={item.is_main} value={true}>Чтение</option>
                      <option selected={!item.is_main} value={false}>Рассылка</option>
                    </select>
                  )}
                </td>
                <td>*****</td>
                <td>*****</td>
              </tr>
            ))}
            {isNeedAddRec ? (
              <tr>
                <td>
                  <input
                    style={{
                      width: `${
                        trRef.current?.children[0]?.clientWidth * 0.8 || 100
                      }px`,
                    }}
                    type="text"
                    value={name}
                    placeholder={`Введите название ${
                      configSource === "avito" ? "ЛК" : "почты"
                    }`}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={used}
                    onChange={(e) => {
                      setUsed(e.target.checked);
                    }}
                  />
                </td>
                <td>
                  {configSource === "avito" ? (
                    <input
                      type="checkbox"
                      checked={main}
                      onChange={(e) => {
                        setMain(e.target.checked);
                      }}
                    />
                  ) : (
                    <select
                      value={main}
                      onChange={(e) => {
                        setMain(e.target.value === "true");
                      }}
                    >
                      <option value="true">Чтение</option>
                      <option value="false">Рассылка</option>
                    </select>
                  )}
                </td>
                <td>
                  <input
                    style={{
                      width: `${
                        trRef.current?.children[3]?.clientWidth * 0.8 || 100
                      }px`,
                    }}
                    type="text"
                    placeholder="Введите логин"
                    value={login}
                    onChange={(e) => {
                      setLogin(e.target.value);
                    }}
                  />
                </td>
                <td>
                  <input
                    style={{
                      width: `${
                        trRef.current?.children[4]?.clientWidth * 0.8 || 100
                      }px`,
                    }}
                    type="text"
                    placeholder="Введите пароль"
                    value={pass}
                    onChange={(e) => {
                      setPass(e.target.value);
                    }}
                  />
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <button className="report_button" onClick={handleAddClick}>
          {!isNeedAddRec
            ? `Добавить ${configSource === "avito" ? "ЛК авито" : "почту"}`
            : "Сохранить"}
        </button>
      </div>
    </>
  );
};

export default EntryConfigTable;
